import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@/components/common/Modal/Modal';
import { LANGUAGES } from '@/i18n';
import styles from './LanguageModal.module.css';

/**
 * LanguageModal Component
 * Full-screen modal for selecting app language
 * Displays all 14 supported languages in a premium grid
 */
const LanguageModal = ({ isOpen, onClose }) => {
  const { i18n, t } = useTranslation();

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('settings.selectLanguage')}
      size="md"
      showCloseButton
    >
      <div className={styles.grid}>
        {LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            className={`${styles.item} ${i18n.language === lang.code ? styles.active : ''}`}
            onClick={() => handleSelect(lang.code)}
          >
            <span className={styles.flag}>{lang.flag}</span>
            <div className={styles.textWrap}>
              <span className={styles.native}>{lang.nativeName}</span>
              <span className={styles.english}>{lang.name}</span>
            </div>
            {i18n.language === lang.code && (
              <svg className={styles.check} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </Modal>
  );
};

export default LanguageModal;
